export default import.meta.ROLLUP_FILE_URL_bLNX6U6f8qE7L2W0pHPLmA;